import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { VariableType } from '@mode-vegas/vegas';
import { ReportTypes } from '@mode/shared/contract-common';
import { trackByFactory } from '@mode/capra';
import { getFieldIcon } from '@mode/shared/util-js';

interface IconDetails {
  name: string | undefined;
  type: VariableType;
}

@Component({
  selector: 'mode-field-tree-view',
  templateUrl: './field-tree-view.component.html',
  styleUrls: ['./field-tree-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldTreeViewComponent implements OnChanges {
  @Input() fields: ReportTypes.ReportFilterFieldTypes[] = [];
  @Input() selectedId: string | undefined;
  @Input() showSearch = false;
  @Output() selectedIdChange = new EventEmitter<string>();
  public fieldIcons = this._getFieldIcons(this.fields);

  public trackById = trackByFactory<ReportTypes.ReportFilterFieldTypes>(({ id }) => id);
  public getId = (field: ReportTypes.ReportFilterFieldTypes) => field.id;
  public getChildren = (field: ReportTypes.ReportFilterFieldTypes) =>
    field.type === ReportTypes.ReportFilterFieldType.Folder ? field.fields : [];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.fields) {
      this.fieldIcons = this._getFieldIcons(changes.fields.currentValue);
    }
  }

  private _getFieldIcons(fields: ReportTypes.ReportFilterFieldTypes[]): Record<string, IconDetails> {
    const fieldIcons: Record<string, IconDetails> = {};
    for (let field of fields) {
      if (field.type === ReportTypes.ReportFilterFieldType.Field) {
        fieldIcons[field.id] = this._getIconDetails(field);
      } else if (field.type === ReportTypes.ReportFilterFieldType.Folder) {
        for (let childField of field.fields) {
          fieldIcons[childField.id] = this._getIconDetails(childField);
        }
      }
    }
    return fieldIcons;
  }

  private _getIconDetails(field: ReportTypes.ReportFilterField): IconDetails {
    const { varType } = field.control;
    const name = getFieldIcon(field.formulaType, field.isCalc);
    return { name, type: varType };
  }
}
